module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-447.2e38312.woff2";